<template>
    <Formulario titulo="Distribuição de Prazos">
      <v-data-table :headers="headers" :items="items" locale="pt-BR">
        <template v-slot:item="props">
          <tr>
            <td class="text-left">{{props.item.name}}</td>
            <td class="text-left">{{props.item.Hoje }}</td>
            <td class="text-left">{{props.item.Amanha }}</td>
            <td class="text-left">{{props.item.Futuros }}</td>
          </tr>
        </template>
      </v-data-table>
    </Formulario>
</template>

<script>
import LayoutSite from "@/components/layout/LayoutSite";
import Formulario from "@/components/Form";

export default {
  data() {
    return {
      headers: [
        { text: "Nome", value: "name" },
        { text: "Hoje", value: "Hoje" },
        { text: "Amanhã", value: "Amanha" },
        { text: "Futuros", value: "Futuros" }
      ],
      items: []
    };
  },
  components: {
    LayoutSite,
    Formulario
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$http
        .get(this.$urlAPI + "/distribuicao", {
          headers: { authorization: "Bearer " + this.$store.getters.getToken }
        })
        .then(response => {
          this.items = response.data;
        });
    }
  }
};
</script>
